import { withStyles } from '@material-ui/core/styles';
import ReceiptFields from './ReceiptFields';
import styles from './ReceiptFields.styles';

export default withStyles(styles)(ReceiptFields);
